'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from '@datadog/browser-rum-react';
import CssBaseline from '@mui/material/CssBaseline';
import { lightTheme } from '@/app/theme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { type FC, type ReactNode, useEffect } from 'react';
import { SessionProvider, getSession, signOut } from 'next-auth/react';
import { ToastProvider } from '@/app/_shared/components/ToastContext';
import { SomethingWentWrong } from '@/app/_shared/components/SomethingWentWrong';
import { ROUTES } from '@/app/routes';
import { type Session } from 'next-auth';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { LicenseInfo } from '@mui/x-license';
interface BaseLayoutProps {
  children: ReactNode;
  session: Session | null;
  /** The login cookie is stale; `getSession` calls `/api/auth/session`, which rewrites it. */
  needsSessionRefresh: boolean;
  muiLicenseKey?: string;
}
export const BaseLayout: FC<BaseLayoutProps> = t0 => {
  const $ = _c(13);
  const {
    children,
    session,
    needsSessionRefresh,
    muiLicenseKey
  } = t0;
  if (muiLicenseKey) {
    LicenseInfo.setLicenseKey(muiLicenseKey);
  }
  let t1;
  if ($[0] !== session?.error) {
    t1 = () => {
      if (session?.error === "RefreshAccessTokenError") {
        signOut();
      }
    };
    $[0] = session?.error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = session?.error;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  let t4;
  let t5;
  if ($[4] !== needsSessionRefresh) {
    t4 = () => {
      if (needsSessionRefresh) {
        getSession();
      }
    };
    t5 = [needsSessionRefresh];
    $[4] = needsSessionRefresh;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CssBaseline />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children) {
    t7 = <ThemeProvider theme={lightTheme}><ToastProvider>{t6}{children}</ToastProvider></ThemeProvider>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== session || $[11] !== t7) {
    t8 = <ErrorBoundary fallback={_temp}><NuqsAdapter><SessionProvider session={session}>{t7}</SessionProvider></NuqsAdapter></ErrorBoundary>;
    $[10] = session;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
function _temp(t0) {
  const {
    resetError
  } = t0;
  return <SomethingWentWrong goBackHref={ROUTES.home} reset={resetError} />;
}